import React from 'react'
import i18next from 'i18next'
import { Button } from 'react-bootstrap'
import { Trans } from 'react-i18next'
import ResponsiveTable from '../../system_wide/responsive_table'
import DealerBrandForm from './dealer_brands_form'
import ActionsDropdown from '../../system_wide/actions_dropdown'
import { showConfirmDialog } from '../../system_wide/confirm_dialog'
import { parseISO, startOfToday, format } from 'date-fns'
import { getDealerBrandStatus } from '../helper'

const { t } = i18next

class DealerBrands extends React.Component {
  static defaultProps = {
    dealerBrands: [],
    brands: [],
    agent: null,
    readonly: false,
    mode: '',
    onChange: () => {},
    closeForm: () => {},
  }

  state = {
    dealer_brands: [],
    current_dealer_brand: null,
  }

  actions = [
    {
      icon: 'fas fa-eye',
      variant: 'outline-primary',
      text: t('actions.view', 'Visualizza'),
      onClick: rowData => {
        this.setState({ mode: 'view' })
        this.addDealerBrand(rowData)
      },
    },
    {
      icon: 'fas fa-edit',
      variant: 'outline-warning',
      text: t('actions.edit', 'Modifica'),
      visible: () => this.props.readonly === false,
      onClick: rowData => {
        this.addDealerBrand(rowData)
      },
    },
    {
      icon: 'fas fa-trash-alt',
      variant: 'outline-danger',
      text: t('actions.delete', 'Elimina'),
      visible: () => this.props.readonly === false,
      onClick: rowData => {
        showConfirmDialog(
          <Trans i18nKey="'components.dealer_brands.delete_brand.title">Elimina associazione</Trans>,
          <Trans i18nKey="components.dealer_brands.delete_brand.msg">
            Per procedere alla cancellazione dell'associazione con il brand <b>{rowData.name}</b> clicca su Elimina
          </Trans>,
          () => {
            let dealer_brands = this.state.dealer_brands.filter(
              dealer_brand => dealer_brand.brand_id !== rowData.brand_id
            )
            this.setState({ dealer_brands }, () => this.props.onChange(this.state.dealer_brands))
          },
          () => {},
          'primary',
          'Elimina'
        )
      },
    },
  ]

  actionsRenderer = ({ rowData }) => {
    return <ActionsDropdown rowData={rowData} actions={this.actions} />
  }

  renderName = rowData => {
    const {
      brand: { name = '' },
    } = rowData

    let status = getDealerBrandStatus(startOfToday(), rowData)
    let dotColor = ''
    switch (status) {
      case 'engaged':
        dotColor = '#4CAF50'
        break
      case 'not_engaged':
        dotColor = '#FF5C5C'
        break
      case 'in_progress':
        dotColor = '#FFA500'
        break
      default:
        dotColor = '#FFA500'
        break
    }

    return (
      <div style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: dotColor,
            display: 'inline-block',
          }}
        />
        <div>
          <strong>{name}</strong>
        </div>
      </div>
    )
  }

  columns = [
    {
      title: '',
      className: 'text-center',
      style: { width: '6%', minWidth: '3rem' },
      data: this.actionsRenderer,
    },
    {
      title: t('components.dealer_brands.brand_name', 'Nome'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '40%' },
      sortable: false,
      data: ({ rowData }) => this.renderName(rowData),
    },
    {
      title: t('components.dealer_brands.code', 'Codice'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '24%', minWidth: '7rem' },
      sortable: false,
      data: 'code',
    },
    {
      title: t('components.dealer_brands.sig_fullname', 'Firmatario'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '30%' },
      sortable: false,
      data: ({ rowData: { sig_fullname } }) => sig_fullname,
    },
    {
      title: t('components.dealer_brands.affiliation_date', 'Data affiliazione'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '30%' },
      sortable: false,
      data: ({ rowData: { affiliation_date } }) => affiliation_date && format(parseISO(affiliation_date), 'dd/MM/yyyy'),
    },
    {
      title: t('components.dealer_brands.relationship_end_date', 'Data fine rapporto'),
      className: 'd-none d-sm-block flex-fill',
      style: { width: '30%' },
      sortable: false,
      data: ({ rowData: { relationship_end_date } }) =>
        relationship_end_date && format(parseISO(relationship_end_date), 'dd/MM/yyyy'),
    },

    {
      title: t('components.dealer_brands.details', 'Dettagli'),
      className: 'd-block d-sm-none flex-fill',
      style: { width: '100%' },
      sortable: false,
      data: ({ rowData }) => {
        return (
          <div>
            <div className="d-flex">{this.renderName(rowData)}</div>
            <div className="d-flex">
              <strong>{t('components.dealer_brands.code', 'Codice')}</strong>: {rowData.code ? rowData.code : '-'}
            </div>
            <div className="d-flex">
              <strong>{t('components.dealer_brands.affiliation_date', 'Data affiliazione')}</strong>:{' '}
              {rowData.affiliation_date ? format(parseISO(rowData.affiliation_date), 'dd/MM/yyyy') : '-'}
            </div>
            <div className="d-flex">
              <strong>{t('components.dealer_brands.relationship_end_date', 'Data fine rapporto')}</strong>:{' '}
              {rowData.relationship_end_date ? format(parseISO(rowData.relationship_end_date), 'dd/MM/yyyy') : '-'}
            </div>
          </div>
        )
      },
    },
  ]

  getColumns = () => {
    return this.columns
  }

  tableDealerBrandsRef = null
  constructor(props) {
    super(props)
    this.tableDealerBrandsRef = React.createRef()
    this.state.dealer_brands = props.dealerBrands
  }

  addDealerBrand = (dealer_brand = {}) => {
    this.setState({
      current_dealer_brand: {
        brand_id: dealer_brand?.brand_id ?? null,
        brand: { name: dealer_brand?.brand?.name ?? '' },
        code: dealer_brand?.code ?? '',
        sig_fullname: dealer_brand?.sig_fullname ?? '',
        sig_ssn: dealer_brand?.sig_ssn ?? '',
        affiliation_date: dealer_brand?.affiliation_date ?? null,
        relationship_end_date: dealer_brand?.relationship_end_date ?? null,
        contract_expires_date: dealer_brand?.contract_expires_date ?? null,
        contract_rejected_date: dealer_brand?.contract_rejected_date ?? null,
        appointments_concluded_date: dealer_brand?.appointments_concluded_date ?? null,
        appointments_rejected_date: dealer_brand?.appointments_rejected_date ?? null,
        appointments_creation_date: dealer_brand?.appointments_creation_date ?? null,
      },
    })
  }

  onAddDealerBrand = dealer_brand => {
    let dealer_brands = this.state.dealer_brands.map(dealer_b => dealer_b.brand_id)
    let _dealer_brands = [...this.state.dealer_brands]
    if (dealer_brands.includes(dealer_brand.brand_id)) {
      _dealer_brands = this.state.dealer_brands.map(dealer_b => {
        if (dealer_b.brand_id === dealer_brand.brand_id) {
          return { ...dealer_b, ...dealer_brand }
        }
        return dealer_b
      })
    } else {
      _dealer_brands.push(dealer_brand)
    }
    this.setState({ dealer_brands: _dealer_brands, mode: '' }, () => this.props.onChange(this.state.dealer_brands))
  }

  render() {
    let { dealer_brands, current_dealer_brand, mode } = this.state
    return (
      <div className="d-flex flex-column" style={{ height: '20rem' }}>
        {this.props.readonly === false && (
          <div className="toolbar flex-wrap">
            <Button size="sm" onClick={this.addDealerBrand}>
              <i className="fas fa-plus fa-fw text-start me-0" />
              <Trans i18nKey="components.dealer_brands.brand">Associa brand</Trans>
            </Button>
          </div>
        )}

        <ResponsiveTable
          ref={this.tableDealerBrandsRef}
          className="flex-fill"
          data={dealer_brands}
          totalRecords={dealer_brands.length}
          columns={this.getColumns()}
          disableMediaQuery={true}
          showMenu={current_dealer_brand !== null}
          modalSize="lg"
          menuContent={DealerBrandForm}
          hideStatusBar={true}
          menuContentProps={{
            title: current_dealer_brand?.brand_id
              ? t('components.dealer_brands.edit_dealer_brand', 'Modifica associazione a brand')
              : t('components.dealer_brands.add_dealer:brand', 'Aggiungi associazione a brand'),
            dealer_brand: current_dealer_brand,
            agent: this.props.agent,
            brands: this.props.brands,
            current_dealer_brands: mode === 'view' || current_dealer_brand?.brand_id ? [] : dealer_brands,
            onSave: this.onAddDealerBrand,
            closeForm: () => {
              this.setState({ current_dealer_brand: null, mode: '' })
            },
            readonly: mode === 'view',

            forceUseModal: true,
          }}
        />
      </div>
    )
  }
}
export default DealerBrands
